import batteryReplacementImg from '../../images/orders/battery-replacement.png'
import orderImg from '../../images/orders/order.png'
import reorderImg from '../../images/orders/reorder.png'
import replacementOrderImg from '../../images/orders/replacement-order.png'
import returnImg from '../../images/orders/return.png'
import scrapImg from '../../images/orders/scrap.png'

const titles = {
  order: 'Order',
  'Battery Replacement Order': 'Battery Replacement',
  'Replacement Order': 'Replacement Order',
  reorder: 'Reorder',
  return: 'Return',
  scrap: 'Scrap',
}

const icons = {
  order: orderImg,
  'Battery Replacement Order': batteryReplacementImg,
  'Replacement Order': replacementOrderImg,
  reorder: reorderImg,
  return: returnImg,
  scrap: scrapImg,
}

export const getOrderTitle = (orderType: IOrderListItem['orderType']) => titles[orderType] ?? orderType

export const getOrderIcon = (orderType: IOrderListItem['orderType']) => icons[orderType] ?? orderImg
